import React from "react";
import { RadioGroupProps as MuiRadioGroupProps } from "@material-ui/core/RadioGroup";

import { FormikRadioGroup } from "./FormikRadioGroup";
import { RawRadioGroup } from "./RawRadioGroup";

interface IProps extends MuiRadioGroupProps {
  inline?: boolean;
  label?: string;
  inFormik?: boolean;
  name?: string;
}

export const RadioGroup: React.FunctionComponent<IProps> = ({
  inFormik,
  name,
  ...props
}: IProps) => {
  if (inFormik && name) {
    return <FormikRadioGroup name={name} {...props} />;
  }
  return <RawRadioGroup {...props} />;
};
